module.exports = __webpack_public_path__ + "static/media/ArrowBack.58b88df8.svg";